// import {
//   errorNotifier,
//   successNotifier,
// } from '../../../components/NotificationHandler';
// import http, { AUTH_ROUTES } from '../../../services/api';

// export const inviteGuest = async (
//   payload,
//   setLoading,
//   setGuestCode,
//   onOpen,
//   onClose
// ) => {
//   try {
//     setLoading(true);
//     const {
//       data: { result },
//     } = await http.post(AUTH_ROUTES.INVITE_GUEST, payload);
//     setGuestCode(result.data.guestCode);

//     successNotifier(result?.message);
//     console.log('result', result);
//     setLoading(false);
//     result.data.guestCode && onOpen();
//     console.log('kkkkk', result.data.guestCode);
//   } catch (error) {
//     onClose();
//     console.log('rrrrr', error.response);
//     error.response.data.message
//       ? errorNotifier(error.response.data.message)
//       : errorNotifier(error.response.data.result.message);
//     setLoading(false);
//   }
// };

import {
  errorNotifier,
  successNotifier,
} from '../../../components/NotificationHandler';
import http, { AUTH_ROUTES } from '../../../services/api';

export const inviteGuest = async (
  payload,
  setLoading,
  setGuestCode,
  onOpen,
  onClose,
  navigate
) => {
  try {
    setLoading(true);
    const {
      data: { result },
    } = await http.post(AUTH_ROUTES.INVITE_GUEST, payload);
    setGuestCode(result.data.guestCode);

    successNotifier(result?.message);
    console.log('result', result);
    setLoading(false);
    result.data.guestCode && onOpen();
    console.log('kkkkk', result.data.guestCode);
    // onClose();
  } catch (error) {
    onClose();
    setLoading(false);
    console.log('rrrrr', error.response);
    console.log(error.response, 'eeerr');
    if (!error.response) {
      errorNotifier('Please Check your internet');
      return;
    }
    error.response.data.message
      ? errorNotifier(error.response.data.message)
      : errorNotifier(error.response.data.result.message);
  }
};
